import React from 'react';
import { Box } from 'rebass';

import { parseSpacing } from '../../utils/parseSpacing';
import { SpacerStoryblok } from '../../types/storyblok';

/**
 * Allows vertical spacing in Editor
 * @param {Object} props
 * @param {string} props.className
 * @param {string} [props.height] - Comma separated list of sizes in steps or pixels.
 * @param {string} [props.width] - Comma separated list of sizes in steps or pixels.
 */
const Spacer = ({ className, height = '', width = '' }: SpacerStoryblok) => (
  <Box
    className={className}
    pt={parseSpacing(height)}
    pr={parseSpacing(width)}
  />
);

export default Spacer;
